var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoBlack = function SvgLogoBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45228 15C9.98533 15 10.8564 13.2457 9.92974 12.0244L6.83845 7.95014C6.43216 7.41467 6.4425 6.67137 6.86354 6.14741L9.46363 2.91166C10.4051 1.74009 9.57104 0 8.06808 0L3.70099 5.8101C3.48607 6.09604 3.03087 5.94404 3.03087 5.58633V3.03087C3.03087 1.35697 1.6739 0 0 0V15C1.6739 15 3.03087 13.643 3.03087 11.9691V11.1888C3.03087 10.6715 3.20629 10.1694 3.52849 9.76467L3.7115 9.53476C3.92685 9.26423 4.3411 9.2745 4.54277 9.55537L8.45228 15Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-black.d5b5f589.svg";
export { ForwardRef as ReactComponent };